import React from "react";
import propTypes from "prop-types";

import { LinkContainer } from "react-router-bootstrap";

import NavDropdown from "react-bootstrap/cjs/NavDropdown";

const NavDropdownItem = ({ to, exact, isActive, children, disabled }) => (
  <LinkContainer
    exact={exact}
    to={to}
    isActive={(match, location) =>
      typeof isActive === "boolean" ? isActive : location.pathname === to
    }
  >
    <NavDropdown.Item disabled={disabled}>{children}</NavDropdown.Item>
  </LinkContainer>
);

NavDropdownItem.propTypes = {
  exact: propTypes.bool,
  to: propTypes.string.isRequired,
  isActive: propTypes.oneOfType([propTypes.bool, propTypes.func]),
  logOutput: propTypes.bool,
  disabled: propTypes.bool,
};

export default NavDropdownItem;
